const BLOCK_TAGS = 'p,div,li,tr,br,blockquote,h1,h2,h3,h4,h5,h6';

function stripHtmlToText(html) {
  if (!html || typeof html !== 'string') return '';
  if (!/<[a-z][\s\S]*>/i.test(html)) return html.trim();
  if (typeof document !== 'undefined') {
    // DOMParser, not a detached div: <img onerror> fires even in a detached div.
    const doc = new DOMParser().parseFromString(html, 'text/html').body;
    doc.querySelectorAll(BLOCK_TAGS).forEach((el) => {
      el.parentNode.insertBefore(doc.ownerDocument.createTextNode('\n'), el);
    });
    return (doc.textContent || '')
      .replace(/[^\S\n]+/g, ' ')
      .replace(/ *\n */g, '\n')
      .replace(/\n{2,}/g, '\n')
      .trim();
  }
  return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function isEssayInstructionBlob(text) {
  const plain = stripHtmlToText(text).toLowerCase();
  if (!plain) return false;
  if (plain.includes('section b') && (plain.includes('answer one') || plain.includes('essay question'))) {
    return true;
  }
  if (plain.includes('writing task') && plain.includes('answer one')) {
    return true;
  }
  if (plain.includes('section 2') && plain.includes('writing task')) {
    return true;
  }
  return false;
}

export function isEssayChoiceGroup(q) {
  return Boolean(
    q
    && Array.isArray(q.essay_options)
    && q.essay_options.length > 0
    && (q.interaction_kind === 'essay_choice_group' || q.is_essay === true)
  );
}

export function resolveEssayPrompts(question) {
  const raw = (question?.essay_options && question.essay_options.length > 0)
    ? question.essay_options
    : [];
  const withLabels = raw.map((opt, idx) => ({
    ...opt,
    label: opt.label || String.fromCharCode(65 + idx),
    text: opt.text || opt.question_text || opt.prompt_text || '',
  }));
  return withLabels.filter((opt) => {
    const text = opt?.text || '';
    return text && !isEssayInstructionBlob(text);
  });
}

export function getEssayPromptDisplayText(prompt, question, { failClosed = false } = {}) {
  const candidates = [
    prompt?.text,
    prompt?.question_text,
  ].filter(Boolean);
  for (const raw of candidates) {
    if (!isEssayInstructionBlob(raw)) {
      return stripHtmlToText(raw);
    }
  }
  const qText = question?.question || '';
  if (qText && !isEssayInstructionBlob(qText)) {
    return stripHtmlToText(qText);
  }
  if (failClosed) return '';
  return candidates.length ? stripHtmlToText(candidates[0]) : '';
}

/** LNAT item pane: never return instruction-blob text. */
export function resolveLnatEssayItemPrompt(question) {
  const options = Array.isArray(question?.essay_options) ? question.essay_options : [];
  for (const opt of options) {
    const text = String(opt?.text || opt?.question_text || opt?.prompt_text || '').trim();
    if (text && !isEssayInstructionBlob(text)) {
      return stripHtmlToText(text);
    }
  }
  const qText = String(question?.question || '').trim();
  if (qText && !isEssayInstructionBlob(qText)) {
    return stripHtmlToText(qText);
  }
  return '';
}
